import React, { useEffect, useState, useRef } from 'react';
import { Box, HStack, Center, Text, Spinner, useTheme } from 'native-base';
import { Platform, Dimensions } from 'react-native';
import Topics from './topics/Topics';
import { useEnvState, useEnvDispatch } from '../../context/env';
import { useAuthState, useAuthDispatch, authUtil } from '../../context/auth';
import { useMessageBusState, useMessageBusDispatch } from '../../context/messagebus';
import { useMessagesDispatch } from '../../context/messages';
import { useTopicsDispatch, useTopicsState, topicsAPI } from '../../context/topics';
import { useUserState, useUserDispatch } from '../../context/user';
import { useOverviewState, useOverviewDispatch, overviewAPI } from '../../context/overview';
import { useModeratorState } from '../../context/moderator';
import { useCategoriesDispatch, useCategoriesState } from '../../context/categories';
import MenuSide from '../content/menus/MenuSide';
import { AVATAR_SIZE, TYPE_IDS_TO_EXCLUDE, TYPE_DM } from '../Constants';
import { DesktopLeftColumnView, DesktopRightColumnView } from '../../responsive/Views';
import UserProfileModal from './common/reusables/UserProfileModal';
import { usePostManager } from '../hooks/usePostManager';
import { useMessageBus } from '../hooks/useMessageBus';
import { addNewUsersToContext, checkPreviousMessageData, toggleUserDMOption } from '../utils/helpers';
import Banner from './common/reusables/Banner';
const ForumHomeScreen = props => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const envState = useEnvState();
  const envDispatch = useEnvDispatch();
  const authState = useAuthState();
  const authDispatch = useAuthDispatch();
  const categoriesState = useCategoriesState();
  const topicsDispatch = useTopicsDispatch();
  const userDispatch = useUserDispatch();
  const userState = useUserState();
  const moderatorState = useModeratorState();
  const overviewState = useOverviewState();
  const overviewDispatch = useOverviewDispatch();
  const {
    getDigestInfo,
    updateTopicPostContents
  } = usePostManager();
  const [nextPage, setNextPage] = useState(0);
  const [hasMoreTopics, setHasMoreTopics] = useState(true);
  const [latestTopicsList, setLatestTopicsList] = useState([]);
  const messagesDispatch = useMessagesDispatch();
  const authUserName = `${envState.discourse_api_username_prefix}.${authState.platform_user_id}`;
  const categoriesDispatch = useCategoriesDispatch();
  const {
    force_reload_topics,
    flagged_post_id,
    update_watching_status_topic_timestamp
  } = useTopicsState();
  const {
    rootProductCategory,
    selectedCategory,
    forumCategories
  } = categoriesState;
  const infoText = ''; // const [infoText, setInfoText] = useState('');
  const {
    topic_id_with_new_category,
    move_reply_original_topic_id,
    move_reply_destination_topic_id,
    pinned_topic_id,
    unpinned_topic_id
  } = moderatorState;
  const startNewTopicButtonRef = useRef(null);

  // manage User Profile (Card) Modal
  const [showUserProfileModal, setShowUserProfileModal] = useState(false);
  const [profileUser, setProfileUser] = useState(false);
  const normalizeAvatar = user => {
    const avatarPrefix = user.avatar_template.indexOf('http') !== -1 ? '' : envState === null || envState === void 0 ? void 0 : envState.base_url;
    const avatarTemplate = avatarPrefix + user.avatar_template.replace(/\{size\}/, AVATAR_SIZE);
    user.avatar_template = avatarTemplate;
    return user;
  };
  const showUserProfile = user => {
    let userWithAvatar = normalizeAvatar(user);
    setProfileUser(userWithAvatar);
    if (props.toggleProfileModal) {
      /* if this is defined, it was passed down via an embeddable,
       * so don't use the component defined in this repo
       * just pass this value back up to the embedder
       */

      props.toggleProfileModal({
        publicProfileUserId: parseInt(userWithAvatar.username.replace(new RegExp(`${envState.discourse_api_username_prefix}\.`), '')),
        isDMable: envState.is_dmable_product && authState.can_send_dms && userWithAvatar.accepts_dm
      });
    } else {
      setShowUserProfileModal(true);
    }
  };
  useEffect(() => {
    if (props.dispatchForumAuth) {
      toggleUserDMOption({
        authState,
        envState,
        authDispatch
      });
    }
  }, [props.dispatchForumAuth]);
  const [showSpinner, setShowSpinner] = useState(true);
  const [showFetchSpinner, setShowFetchSpinner] = useState(false);
  const [reply, setReply] = useState({});
  useEffect(() => {
    var _envState$base_url;
    if (envState !== null && envState !== void 0 && (_envState$base_url = envState.base_url) !== null && _envState$base_url !== void 0 && _envState$base_url.length && authState !== null && authState !== void 0 && authState.api_key && rootProductCategory !== null && rootProductCategory !== void 0 && rootProductCategory.id && (!envState.has_default_category_product || selectedCategory !== null && selectedCategory !== void 0 && selectedCategory.id)) {
      loadContents();
    }
  }, [topic_id_with_new_category, move_reply_original_topic_id, move_reply_destination_topic_id, pinned_topic_id, unpinned_topic_id, flagged_post_id, update_watching_status_topic_timestamp, envState.product, rootProductCategory, selectedCategory]);
  useEffect(() => {
    if (props.selectedCategory) {
      const category = forumCategories.find(c => c.slug === props.selectedCategory);
      if (category) {
        categoriesDispatch({
          type: 'SET_SELECTED_CATEGORY',
          payload: category
        });
      }
    }
  }, [props.selectedCategory, forumCategories]);
  useEffect(() => {
    if (latestTopicsList.length) {
      setShowFetchSpinner(false);
    }
  }, [latestTopicsList]);
  useEffect(() => {
    if (force_reload_topics) {
      loadContents();
      topicsDispatch({
        type: 'SET_FORCE_RELOAD_TOPICS',
        payload: false
      });
    }
  }, [force_reload_topics]);
  const loadContents = () => {
    getTopics();
  };
  const delay = () => {
    return new Promise(resolve => setTimeout(resolve, 1));
  };
  useEffect(() => {
    (async function () {
      if (props.forumKey && props.forumKey.path && props.forumKey.path.post) {
        if (props.forumKey.path.post === 'topic') {
          await delay();
          props.navigation.navigate('SingleTopic', {
            topicId: props.forumKey.path.id,
            normalizeUrl: true,
            loadContents,
            showUserProfile,
            trackForum: props.trackForum
          });
        } else if (props.forumKey.path.post === 'reply') {
          const response = await topicsAPI.getReply(envState.base_url, authState.api_key, props.forumKey.path.id);
          setReply(response);
          if (reply && reply.id && reply.topic_id) {
            props.navigation.navigate('SingleTopic', {
              topicId: reply.topic_id,
              normalizeUrl: true,
              replyId: reply.id,
              reply: reply,
              loadContents,
              showUserProfile,
              trackForum: props.trackForum
            });
          }
        } else if (props.forumKey.path.post === 'dm') {
          // Navigate to PrivateMessage screen
          return checkPreviousMessageData({
            authState,
            envState,
            userState,
            overviewState,
            messagesDispatch,
            dispatchUserContext: true,
            navigation: props.navigation,
            topicId: props.forumKey.path.id,
            users: props.forumKey.path.username && [{
              username: props.forumKey.path.username
            }]
          });
        }
      }
      setShowSpinner(false);
    })();
  }, [props.forumKey]);
  const getActivity = async () => {
    await Promise.all([getNotifications(), getMessages()]);
  };
  useEffect(() => {
    if (envState.base_url && authUserName && authState.api_key && forumCategories.filter(c => c).length) {
      getActivity();
    }
  }, [envState.base_url, authUserName, authState.api_key, forumCategories]);
  const getNotifications = async () => {
    let allProductCategories = [rootProductCategory, categoriesState.rootForumCategory, ...forumCategories].map(c => c.id).filter(c => c);
    let retrievedNotifications = await overviewAPI.getNotifications(envState.base_url, authUserName, authState.api_key, 'all');

    // retrieved notifications includes unread DMs. Let's parse this out now
    retrievedNotifications = retrievedNotifications.filter(item => {
      return !TYPE_IDS_TO_EXCLUDE.includes(item.notification_type);
    });
    const notifications = {
      activity: [],
      message: []
    };
    retrievedNotifications.forEach(n => {
      n.notification_type === TYPE_DM ? notifications.message.push(n) : (authState.moderator || allProductCategories.includes(n.category_id)) && notifications.activity.push(n);
    });
    const unreadNotifications = notifications.activity.filter(n => !n.read);
    const unreadMessages = notifications.message.filter(n => !n.read);
    overviewDispatch({
      type: 'SET_NOTIFICATIONS',
      payload: notifications
    });
    overviewDispatch({
      type: 'SET_UNREAD_ACTIVITY_COUNT',
      payload: unreadNotifications.length
    });
    overviewDispatch({
      type: 'SET_UNREAD_MESSAGES_COUNT',
      payload: unreadMessages.length
    });
    return retrievedNotifications;
  };
  const getMessages = async () => {
    const res = await overviewAPI.getPrivateMessages(envState.base_url, authUserName, authState.api_key);
    if (res) {
      var _res$topic_list, _res2$topic_list;
      let privateMessages = ((_res$topic_list = res.topic_list) === null || _res$topic_list === void 0 ? void 0 : _res$topic_list.topics) || [];
      const res2 = await overviewAPI.getPrivateMessagesSent(envState.base_url, authUserName, authState.api_key);
      const privateMessagesSent = (res2 === null || res2 === void 0 || (_res2$topic_list = res2.topic_list) === null || _res2$topic_list === void 0 ? void 0 : _res2$topic_list.topics) || [];
      privateMessages = [...privateMessages, ...privateMessagesSent].sort((a, b) => a.last_posted_at < b.last_posted_at ? 1 : -1).reduce((accum, m) => {
        let uniqueMessages = accum.map(a => a.id);
        if (!(m !== null && m !== void 0 && m.id) || uniqueMessages.includes(m.id)) {
          return accum;
        } else {
          return [...accum, m];
        }
      }, []);
      overviewDispatch({
        type: 'SET_MESSAGES',
        payload: privateMessages
      });
    }
  };
  const updateTopicReplies = () => {
    setHasMoreTopics(true);
    messageBusDispatch({
      type: 'INIT_REPLIES'
    });
  };
  const updateTopicPost = (id, post) => {
    updateTopicPostContents(id, post, latestTopicsList, setLatestTopicsList);
  };
  useEffect(() => {
    // selectedCategory here to avoid double-call of loadContents when we change categories
    if (hasMoreTopics && !nextPage && !selectedCategory) {
      loadContents();
    }
  }, [nextPage, hasMoreTopics, selectedCategory]);
  const getTopics = async () => {
    setShowFetchSpinner(true);
    let response;
    if (hasMoreTopics) {
      response = await topicsAPI.handleLatestTopicsBySelectedCategory(envState.base_url, authState.api_key, envState.product, rootProductCategory, selectedCategory, nextPage);
    }
    if (response) {
      var _response;
      // save users in context
      if (response.users) {
        addNewUsersToContext(userState, userDispatch, response.users);
      }
      if (response.topic_list && response.topic_list.topics && response.topic_list.topics.length) {
        setNextPage(currentPage => currentPage + 1); // for pagination

        // save topics in context and component state
        const {
          topics
        } = response.topic_list;

        // now we get some digest info
        await getDigestInfo(topics);
        let latestTopics;
        if (!nextPage) {
          latestTopics = topics.sort((a, b) => b.pinned - a.pinned);
          setLatestTopicsList(latestTopics);
        } else {
          // need to ensure uniqueness
          latestTopics = topics.reduce((accum, current) => {
            let topicsSoFar = accum.map(a => a.id);
            if (topicsSoFar.includes(current.id)) {
              return accum;
            } else {
              return [...accum, current];
            }
          }, latestTopicsList);
          setLatestTopicsList(latestTopics);
        }
        setShowFetchSpinner(false);
        return latestTopics;
      }
      if (!((_response = response) !== null && _response !== void 0 && (_response = _response.topic_list) !== null && _response !== void 0 && (_response = _response.topics) !== null && _response !== void 0 && _response.length)) {
        setHasMoreTopics(false); // no need for loadMoreTopics api request
      }
    } else {
      setHasMoreTopics(false); // no need for loadMoreTopics api request
      setShowFetchSpinner(false);
      return false;
    }
    setShowFetchSpinner(false);
    return false;
  };
  const informationText = /*#__PURE__*/React.createElement(Center, {
    mt: 8,
    mb: 10
  }, /*#__PURE__*/React.createElement(Text, {
    color: colors.forumHomeScreen.infoText
  }, infoText));
  const updateForceReloadTopics = async () => {
    topicsDispatch({
      type: 'SET_FORCE_RELOAD_TOPICS',
      payload: true
    });
  };

  /**
   * Initialize the MessageBus, the call startPollingForMessages() to establish polling/listening
   *  initialized means the script was found and valid context/state vars exist
   *  startPollingForMessages sets the isListening value to true
   */

  const {
    isInitialized,
    closeTopicBanner,
    closeReplyBanner,
    refreshTopics,
    refreshTopic,
    startPollingForMessages,
    pauseMessageBus,
    getUniqueList
  } = useMessageBus({
    userAuthenticated: authUtil.userAuthed(authState)
  });

  // once initialized, start the message bus, start polling for new messages
  useEffect(() => {
    if (isInitialized) {
      startPollingForMessages({
        baseUrl: envState.base_url,
        userApiKey: authState.api_key,
        discourseUserId: authState.discourse_user_id
      });
    }
  }, [isInitialized]);
  useEffect(() => {
    /* return means this function is called upon cleanup/dismount
     * I wanted to combine this with the useEffect above
     * calling startPollingForMessages, but kept getting script errors */
    return function () {
      pauseMessageBus();
    };
  }, []);

  /**
   * MessageBus [refresh all topics] banner actions
   *  similar code exists in the Topics component (to handle replies)
   */

  /**
   * define state vars
   *  messageBusActivityTimestamp will be used for mentions and DMs
   *  topicIdList and topicId are used by topic and reply
   */
  const messageBusState = useMessageBusState();
  const messageBusDispatch = useMessageBusDispatch();
  const [messageBusActivityTimestamp, setMessageBusActivityTimestamp] = useState(0);
  const [topicIdListForTopics, setTopicIdListForTopics] = useState([]);
  const [topicId, setTopicId] = useState(0);

  /**
   * useEffect
   *    on messageBusState.topics change
   *      if topics has length, set id and list to matching topic id of 1
   *      else, init values to hide banner
   */
  useEffect(() => {
    if (messageBusState.topics.length && !messageBusState.update_in_progress) {
      setTopicIdListForTopics([1]);
      setTopicId(1);
    } else {
      setTopicIdListForTopics([]);
      setTopicId(0);
    }
  }, [messageBusState.topics, messageBusState.update_in_progress]);

  /**
   * useEffect
   *    on messageBusState.activityTimestamp change
   *      when timestamps do not match re-fetch data
   */
  useEffect(() => {
    if (messageBusState.activityTimestamp !== messageBusActivityTimestamp) {
      setMessageBusActivityTimestamp(messageBusState.activityTimestamp);
      getActivity();
    }
  }, [messageBusState.activityTimestamp]);
  const refreshBanner = () => {
    refreshTopics();
    updateTopicReplies();
    updateForceReloadTopics();
  };
  if (showSpinner) return /*#__PURE__*/React.createElement(Box, {
    h: Dimensions.get('window').height
  }, /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  }, /*#__PURE__*/React.createElement(Spinner, null), /*#__PURE__*/React.createElement(Text, null, "Loading Topics ...")));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HStack, {
    space: 1,
    justifyContent: {
      base: 'none',
      lg: 'center'
    },
    p: {
      base: 0,
      lg: 5
    }
  }, /*#__PURE__*/React.createElement(DesktopLeftColumnView, null, /*#__PURE__*/React.createElement(Center, {
    mt: Platform.OS === 'web' ? '0' : '21%',
    pb: Platform.OS === 'web' ? '0' : '21%'
  }, /*#__PURE__*/React.createElement(Box, {
    w: '100%',
    h: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    bg: colors.forumHomeScreen.bg,
    onLayout: event => {
      var _event$nativeEvent;
      envDispatch({
        type: 'SET_LAYOUT_WIDTH',
        payload: event === null || event === void 0 || (_event$nativeEvent = event.nativeEvent) === null || _event$nativeEvent === void 0 || (_event$nativeEvent = _event$nativeEvent.layout) === null || _event$nativeEvent === void 0 ? void 0 : _event$nativeEvent.width
      });
    }
  }, /*#__PURE__*/React.createElement(Banner, {
    type: 'topic',
    refresh: refreshBanner,
    close: closeTopicBanner,
    topicIdList: topicIdListForTopics,
    topicId: topicId
  }), /*#__PURE__*/React.createElement(Topics, {
    topics: latestTopicsList,
    updateTopicPost: updateTopicPost,
    updateTopicReplies: updateTopicReplies,
    loadContents: loadContents,
    navigation: props.navigation,
    loadMoreTopics: getTopics,
    updateForceReloadTopics: updateForceReloadTopics,
    showUserProfile: showUserProfile,
    getUniqueList: getUniqueList,
    closeReplyBanner: closeReplyBanner,
    refreshTopic: refreshTopic,
    trackForum: props.trackForum,
    startNewTopicButtonRef: startNewTopicButtonRef,
    setNextPage: setNextPage,
    hasMoreTopics: hasMoreTopics,
    setHasMoreTopics: setHasMoreTopics,
    showFetchSpinner: showFetchSpinner,
    reply: reply
  })))), /*#__PURE__*/React.createElement(DesktopRightColumnView, null, /*#__PURE__*/React.createElement(MenuSide, {
    navigation: props.navigation,
    startNewTopicButtonRef: startNewTopicButtonRef,
    isGuidelineModalOpen: props.isGuidelineModalOpen,
    setIsGuidelineModalOpen: props.setIsGuidelineModalOpen,
    setPage: setNextPage,
    setHasMoreTopics: setHasMoreTopics
  }))), profileUser && !props.toggleProfileModal && /*#__PURE__*/React.createElement(UserProfileModal, {
    profileUser: profileUser,
    setShowUserProfileModal: setShowUserProfileModal,
    showUserProfileModal: showUserProfileModal
  }));
};
export default ForumHomeScreen;
//# sourceMappingURL=ForumHomeScreen.js.map